import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import Dialog, { DialogTitle, DialogActions } from "material-ui/Dialog";
import Icon from 'material-ui/Icon'
import Button from "material-ui/Button";
import { post } from '../../services/apiServices'
import { token } from '../../services/authServices'

const styles = {
    closeIcon: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        color: '#a9a9a9',
        cursor: 'pointer'
    },
    editIcon: {
        padding: '10px',
        cursor: 'pointer'
    },
    button: {
        width: '120px',
        margin: '0 auto 40px'
    },
    titleWrap: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        color: '#3f51b5'
    },
    table: {
        minWidth: 700,
    },
    tableRow: {
        cursor: 'pointer'
    },
    listItem: {
        width: "480px",
        alignItems: "flex-start",
        borderBottom: "1px solid rgba(224, 224, 224, 1)"
    },
    listItemText: {
        flex: "1 1 50%"
    },
    listItemTtitle: {
        fontWeight: 600
    },
    progressWrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    progress: {
    }
};
class Cache extends Component {
    classes = this.props.classes;
    state = {
        openClearClientsCacheModal: false,
        openClearServerCacheModal: false,
        openClearCloudflareCacheModal: false
    }

    handleOpenClientsCache = e => {
        this.setState({ openClearClientsCacheModal: true })
    };

    handleOpenServerCache = e => {
        this.setState({ openClearServerCacheModal: true })
    };

    handleOpenCloudflareCache = e => {
        this.setState({ openClearCloudflareCacheModal: true })
    };

    async clearClientsCache() {
        await post('/admin/cache/clearClients', {}, token)
        this.closeClientsCache()
    };

    closeClientsCache = e => {
        this.setState({ openClearClientsCacheModal: false })
    }

    async clearServerCache() {
        await post('/admin/cache/clearServer', {}, token)
        this.closeServerCache()
    };

    closeServerCache = e => {
        this.setState({ openClearServerCacheModal: false })
    }

    async clearCloudflareCache() {
        await post('/admin/cache/clearCloudflare', {}, token)
        this.closeCloudflareCache()
    };

    closeCloudflareCache = e => {
        this.setState({ openClearCloudflareCacheModal: false })
    }

    render() {
        return (
            <div>
                <div className={this.classes.titleWrap}>
                    <h2 className={this.props.classes.title}>Cache</h2>
                </div>
                <Button
                    variant="raised"
                    color="primary"
                    style={{ display: 'block' }}
                    onClick={() => this.handleOpenClientsCache()}>
                    Clear clients cache
                </Button>
                <Button
                    variant="raised"
                    color="primary"
                    style={{ display: 'block', marginTop: '30px' }}
                    onClick={() => this.handleOpenServerCache()}>
                    Clear server cache
                </Button>
                <Button
                    variant="raised"
                    color="primary"
                    style={{ display: 'block', marginTop: '30px' }}
                    onClick={() => this.handleOpenCloudflareCache()}>
                    Clear cloudflare cache
                </Button>
                <Dialog
                    open={this.state.openClearClientsCacheModal}
                    onClose={() => this.closeClientsCache()}>
                    <DialogTitle>
                        <Icon
                            className={this.classes.closeIcon}
                            onClick={() => this.closeClientsCache()}>
                            close
                        </Icon>
                        <br />
                        Are you sure you want clear clients cache?
                    </DialogTitle>
                    <DialogActions className={this.classes.justifyCenter}>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={() => this.clearClientsCache()}>
                            Yes
                        </Button>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={() => this.closeClientsCache()}>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.openClearServerCacheModal}
                    onClose={() => this.closeServerCache()}>
                    <DialogTitle>
                        <Icon
                            className={this.classes.closeIcon}
                            onClick={() => this.closeServerCache()}>
                            close
                        </Icon>
                        <br />
                        Are you sure you want clear server cache?
                    </DialogTitle>
                    <DialogActions className={this.classes.justifyCenter}>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={() => this.clearServerCache()}>
                            Yes
                        </Button>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={() => this.closeServerCache()}>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.openClearCloudflareCacheModal}
                    onClose={() => this.closeCloudflareCache()}>
                    <DialogTitle>
                        <Icon
                            className={this.classes.closeIcon}
                            onClick={() => this.closeCloudflareCache()}>
                            close
                        </Icon>
                        <br />
                        Are you sure you want clear cloudflare cache?
                    </DialogTitle>
                    <DialogActions className={this.classes.justifyCenter}>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={() => this.clearCloudflareCache()}>
                            Yes
                        </Button>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={() => this.closeCloudflareCache()}>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )

    }
}

export default withStyles(styles)(Cache);


// WEBPACK FOOTER //
// ./src/components/content/Cache.js